<template>
  <div data-component-group="line-item-dialog" data-component="add-new">
    <dialog-add
      icon=""
      :title="$t('new_line_item')"
      is-fullscreen
      :is-on="isOn"
      :on-close="onCancel"
    >
      <template v-slot:content>
        <AddLineItemForm
          :order="order"
          :line-item="{}"
          :is-on="isOn"
          :is-loading="isLoading"
          :is-updating="isUpdating"
          :on-cancel="onCancel"
          :on-submit="onConfirm"
          class="elevation-1"
        />
      </template>
    </dialog-add>
  </div>
</template>

<script>
  import AddLineItemForm from '../../forms/line/AddNew';

  export default {
    components: {
      AddLineItemForm,
    },
    props: {
      order: {
        type: Object,
        required: true,
      },
      isOn: {
        type: Boolean,
        default: false,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      isUpdating: {
        type: Boolean,
        required: true,
      },
      onCancel: {
        type: Function,
        required: true,
      },
      onConfirm: {
        type: Function,
        required: true,
      },
    },
  };
</script>
